'use strict';

import $ from 'jquery';

/**
 * This module has some random helper stuff in it
 */
const helper = {
  serverTimeOffset: 0, // If browser time is synchronized with server time, the offset is stored here
  _timeouts: {},

    /**
   * Update time left until the end of the auction
   * - If >24h, show static time (for example 4.5. klo 18:00)
   * - If <24h, show countdown (for example 00:15:37)
   * - If no time left, auction has ended - disable form
   *
   * @param {string}   auctionId - The auction id of the lift
   * @param {int}      endTime - The new end time of the auction
   * @param {function} callback - Function to call when timer reaches zero
   */
  updateTimeLeft: function(auctionId, endTime, callback) {
    const self = this;
    let timeLeftSeconds = parseInt((endTime - (Date.now() + this.serverTimeOffset)) / 1000);
    let timeLeftString = '';

    if (timeLeftSeconds <= 0) {
      // Auction has ended.
      timeLeftString = window.translations.auctions_auction_has_ended;

      //Hide time label also
      $('.auction-end-time-' + auctionId).siblings('.time-label').hide();

      // Disable bid form
      $('#make-bid-box, #auction-bid-modal').remove();

      if(typeof callback === 'function') {
        callback();
      }

    } else if (timeLeftSeconds < 60 * 60 * 24) {
      // Less than 24h left of auction. Show countdown view.
      timeLeftString = helper.formatTimeLeft(timeLeftSeconds);

      // Update time every second
      const timeoutName = 'updateTimeLeft' + auctionId;
      if (typeof self._timeouts[timeoutName] !== 'undefined') {
        clearTimeout(self._timeouts[timeoutName]);
      }
      self._timeouts[timeoutName] = setTimeout(function(){
        self.updateTimeLeft(auctionId, endTime, callback);
      }, 1000);

    } else {
      // More than 24h left. Show static time.
      timeLeftString = helper.formatStaticTime(endTime);
    }

    $('.auction-end-time-' + auctionId).text(timeLeftString);
  },

  /**
   * When clicking on an element that has a data-click-target attribute,
   * click the target specified there instead if the element itself.
   * If target element is not found, then click works normally.
   *
   * This is used in the login modals "forgot password" link
   * to make it work with the bootstrap tabs
   *
   * @param {event}   event  The click event
   */
  _clickTargetHandler: function (event) {
    const $clickTarget = $($(event.target).data('click-target'));

    if ($clickTarget.length > 0) {
      event.preventDefault();
      $clickTarget.click();
    }
  },

  /**
   * Mobile menu submenu opener
   *
   * @param {object} event The click event
   */
  _menuToggler: function(event){
    $('.level-0 > li.open').removeClass('open');
    $(event.target).closest('.level-0 > li').addClass('open');
  },

  /**
   * Custom validation for registration form
   *
   * @param {event} event The submit event
   */
  _validateCheckboxes: function (event) {
    // Remove class "invalid" from required checkboxes
    $(event.target).closest('form').find('input[type="checkbox"]:required')
      .removeClass('invalid')

      // Add class "invalid" to required checkboxes that aren't checked
      .filter(':not(:checked)')
      .closest('.checkbox-container')
      .addClass('invalid');

    // Browser validation will take care that the form is not submitted
  },

  /**
   * Format static datetime
   *
   * @param  {int}     time Time in unix timestamp
   * @return {string}       Formatted time
   */
  formatStaticTime: function(time) {
    // Turn time into a Date object
    if (typeof time === 'string' && time.match(/^\d+$/)) {
      time = parseInt(time);
    }

    if (typeof time === 'number') {
      time = new Date(time);
    }

    return (
      time.getDate() +
      '.' +
      (time.getMonth() + 1) +
      '.' +
      //time.getFullYear() +
      ' ' +
      window.translations.general_clock +
      ' ' +
      time.getHours() +
      ':' +
      this.addLeadingZeroToTimes(time.getMinutes())
    );
  },

  /**
   * Format time left (for example 00:15:37)
   *
   * @param  {int}     timeLeftSeconds How many seconds are left
   * @return {string}                  Formatted time
   */
  formatTimeLeft: function(timeLeftSeconds) {
    // Hours left
    var timeLeftHours = parseInt(timeLeftSeconds / 60 / 60);
    timeLeftSeconds -= timeLeftHours * 60 * 60;

    // Minutes left
    var timeLeftMinutes = parseInt(timeLeftSeconds / 60);
    timeLeftSeconds -= timeLeftMinutes * 60;

    return (
      this.addLeadingZeroToTimes(timeLeftHours) +
      ':' +
      this.addLeadingZeroToTimes(timeLeftMinutes) +
      ':' +
      this.addLeadingZeroToTimes(timeLeftSeconds)
    );
  },

  /**
   * Format time left in a long format ( 29 minutes 3 seconds )
   *
   * @param  {int}     value How many seconds are left
   * @return {string}                  Formatted time
   */
  formatTimeLeftLong: function(value) {

    // Input = milliseconds, output = DD days, HH hours, MM minutes, SS seconds
    // If timeLeft < 1 day, we leave days out. If timeLeft < 1h, we leave days and hours out, etc.

    let timeLeftSeconds = parseInt(value) / 1000;

    // Days left
    const timeLeftDays = parseInt(timeLeftSeconds / 60 / 60 / 24); // Round down
    timeLeftSeconds -= timeLeftDays * 60 * 60 * 24;

    // Hours left
    const timeLeftHours = parseInt(timeLeftSeconds / 60 / 60); // Round down
    timeLeftSeconds -= timeLeftHours * 60 * 60;

    // Minutes left
    const timeLeftMinutes = parseInt(timeLeftSeconds / 60); // Round down
    timeLeftSeconds -= timeLeftMinutes * 60;

    // Format to a single string
    let returnString = parseInt(timeLeftSeconds) + ' ' + window.TRANSLATIONS['time__seconds'];

    if (parseInt(value) > 1000 * 60) {
      returnString = timeLeftMinutes + ' ' + window.TRANSLATIONS['time__minutes'] + ' ' + returnString;

      if (parseInt(value) >= 1000 * 60 * 60) {
        returnString = timeLeftHours + ' ' + window.TRANSLATIONS['time__hours'] + ' ' + returnString;

        if (parseInt(value) >= 1000 * 60 * 60 * 24) {
          returnString = timeLeftDays + ' ' + window.TRANSLATIONS['time__days'] + ' ' + returnString;
        }
      }
    }

    return returnString;
  },

  /**
   * Add leading zero to minutes or seconds
   *
   * @param {number} i   Number to add leading zero
   * @return {string}    Number with leading zero
   */
  addLeadingZeroToTimes: function(i) {
    return ('0' + i).slice(-2);
  },

  /**
   * Format price to locale string according to stage language version.
   *
   * @param  {mixed}   price    Price, string or number
   * @param  {boolean} decimals Include decimals. Default is false.
   * @return {string}           Formatted price
   */
  formatPrice: function(price, decimals) {
    if (decimals) {
      const wholeNumberPart = parseInt(typeof price === 'string' ? price.replace(/\s/g, '') : price);
      let decimalPart = parseInt((price - wholeNumberPart) * 100).toString();
      while (decimalPart.length < 2) {
        decimalPart += '0';
      }
      return wholeNumberPart + ',' + decimalPart;
    }
    return parseInt(price.toString().replace(/\s/g, '')).toLocaleString(window.lang);
  },

  /**
   * Open correct tab if a corresponding hash is found in the url
   */
  openTabByHash: function() {
    var hash = location.hash;
    if (!hash) {
      return;
    }

    var tab = $('[data-url-hash="' + hash + '"]');
    if (tab.length > 0) {
      tab.prop('checked', true);
    }
  },

  /**
   * Synchronize browser time with server
   *
   * @param {string} serverTime The time we get from the server, taken from an AJAX request's headers
   * @param {int} offset How long the AJAX request took, in ms (using difference between Date.now() before and after request)
   */
  syncTimeWithServer: function(serverTime, offset) {
    try {
      const serverTimeOffset = parseInt(new Date(serverTime).getTime() + offset / 2) - Date.now();

      // Check that estimated server time is sane (max offset 10 years)
      if (!isNaN(serverTimeOffset) && Math.abs(serverTimeOffset) < 1000 * 60 * 60 * 24 * 365 * 10) {
        this.serverTimeOffset = serverTimeOffset;
      }
    } catch (e) {
      // Do nothing
    }
  },

  init: function() {
    $('body').on('click', '[data-click-target]', this._clickTargetHandler);
    $('body').on('click', this._menuToggler);

    // Custom validation for checkboxes, because the actual checkboxes are hidden
    $('body').on('click', 'form [type="submit"]', this._validateCheckboxes);

    if ($('[data-url-hash]').length > 0) {
      // Open correct tab if a corresponding hash is found in the url
      this.openTabByHash();

      // Same as above, but without pageload
      $('[data-trigger-url-hash]').on('click', function(event){
        $('[data-url-hash="' + $(this).data('trigger-url-hash') + '"]').prop('checked', true);
      });
    }
  }
};

module.exports = helper;
